import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import { StatusIcon } from "./WordRow";
import type { EditorWord } from "./types";

export interface WordCardProps {
  word: EditorWord;
  value: string;
  onChange: (value: string) => void;
}

export function WordCard({ word, value, onChange }: WordCardProps) {
  return (
    <Card>
      <CardHeader
        avatar={<StatusIcon status={word.status} />}
        title={word.key}
        subheader={word.label}
      />
      <CardContent>
        <TextField
          value={value}
          onChange={(event) => onChange(event.target.value)}
          fullWidth
          multiline
          minRows={4}
          autoFocus
          variant="outlined"
        />
      </CardContent>
    </Card>
  );
}
